import styled from "styled-components";


const ButtonBar = styled.div`
  display: flex; 
  gap: 1rem; 
  margin-top: 10px; 
  margin-bottom: 10px;
`;

const PlainButtonBar = styled.div`
  display: flex; 
  gap: 1rem; 
`;

interface PrimaryAndSecondaryButtonProps {
  $small?: boolean;
}
const PrimaryButton = styled.button<PrimaryAndSecondaryButtonProps>`
  padding: ${(props) => (props.$small ? '0.3rem 0.6rem' : '0.5rem 1rem')};
  border: 0px solid var(--border-color);
  border-radius: 0.25rem; 
  color: var(--on-primary);
  background-color: var(--primary);
  transition: background-color 0.15s ease;
  font-size: ${(props) => (props.$small ? '1.05rem' : '1.1rem')};

  &:hover {
    background-color: var(--primary-hover);
  }

  &:disabled {
    color: var(--on-disabled);
    background-color: var(--disabled);
  }
`;

const SecondaryButton = styled.button<PrimaryAndSecondaryButtonProps>`
  padding: ${(props) => (props.$small ? '0.3rem 0.6rem' : '0.5rem 1rem')};
  border: 0px solid var(--border-color);
  border-radius: 0.25rem; 
  color: var(--on-primary);
  background-color: var(--secondary);
  transition: background-color 0.15s ease;
  font-size: ${(props) => (props.$small ? '1.05rem' : '1.1rem')};

  &:hover {
    background-color: var(--secondary-hover);
  }

  &:disabled {
    color: var(--on-disabled);
    background-color: var(--disabled);
  }
`;

const SecondaryEmailButton = styled.a<PrimaryAndSecondaryButtonProps>`
  padding: ${(props) => (props.$small ? '0.3rem 0.6rem' : '0.5rem 1rem')};
  border: 0px solid var(--border-color);
  border-radius: 0.25rem; 
  color: var(--on-primary);
  background-color: var(--secondary);
  transition: background-color 0.15s ease;
  font-size: ${(props) => (props.$small ? '1.05rem' : '1.1rem')};
  text-decoration: none;

  &:hover {
    background-color: var(--secondary-hover);
  }

  &:disabled {
    color: var(--on-disabled);
    background-color: var(--disabled);
  }
`;

interface ButtonProps {
  $borderless?: boolean;
  $hoverVisible?: boolean;
  $small?: boolean;
}
const Button = styled.button<ButtonProps>`
  background: ${(props) => (props.$borderless ? 'transparent' : 'var(--primary)')};
  color: ${(props) => (props.$borderless ? 'var(--primary)' : 'var(--on-primary)')};
  border: ${(props) => (props.$borderless ? '1px solid transparent' : `1px solid var(--primary)`)};
  padding: ${(props) => (props.$small ? '2px 2px' : '5px 5px')};
  border-radius: ${(props) => (props.$small ? '12px' : '20px')};
  display: ${(props) => (props.$small ? 'flex' : 'block')};
  cursor: pointer;
  opacity: ${(props) => (props.$hoverVisible ? 0 : 1)};
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 1; /* Ensures button is fully visible when hovered */
  }

  &:focus {
    outline: none;
  }

  &.hover-button {
    opacity: ${(props) => (props.$hoverVisible ? 0 : 'initial')};
  }
`;


export { PrimaryButton, SecondaryButton, ButtonBar, Button, SecondaryEmailButton, PlainButtonBar };